import React from 'react'
import s from './Header.module.scss'

import Logo from 'assets/images/dogmented/logo.svg'

export default function Header(props) {
  return (
    <div className={s.header}>      
      <a href="/" className={s.logo}>
        <img src={Logo} alt='Kia' />
      </a>
    </div>
  );
}
